import type { GraphQL } from '@libs/trip-planner-interfaces';

import { assertSmartSearchList } from '../..';

export function toBookingTokensResponse(
  bookingTokensResponseQL: GraphQL.getTicketBookingTokensQuery['bookingTokens']
): string[] {
  assertSmartSearchList(bookingTokensResponseQL);

  return bookingTokensResponseQL;
}
